const colors = {
  blueColor: "#293586",
};
export { colors };
